import { SET_IS_OPEN_MODAL } from '../actionTypes';
import { templatesActions } from '../reducer';

export default (value) => templatesActions[SET_IS_OPEN_MODAL](value);
